
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-statement",
      function () {
        return require("private-next-pages/privacy-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-statement"])
      });
    }
  